import React from "react";

interface IProps {
  width?: number;
  height?: number;
  viewBox?: string;
  fill?: string;
  color?: string;
}

const CopyDownloadIcon: React.FC<IProps> = (props) => {
  const {
    width = 16,
    height = 16,
    viewBox = "0 0 16 16",
    fill = "none",
    color = "#7C7C7C"
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.833252H7.29573C6.07055 0.833239 5.10013 0.833232 4.34065 0.935346C3.55904 1.04043 2.92641 1.26184 2.42749 1.76075C1.92859 2.25966 1.70717 2.89229 1.60209 3.67391C1.49998 4.43338 1.49999 5.4038 1.5 6.62896V10.6666C1.5 11.9147 2.4147 12.9493 3.61034 13.1364C3.70232 13.6457 3.87835 14.0805 4.23223 14.4344C4.63351 14.8357 5.13876 15.0083 5.73883 15.0889C6.31681 15.1666 7.05167 15.1666 7.9634 15.1666H10.0366C10.9483 15.1666 11.6832 15.1666 12.2612 15.0889C12.8613 15.0083 13.3665 14.8357 13.7678 14.4344C14.1691 14.0331 14.3417 13.5279 14.4223 12.9278C14.5 12.3498 14.5 11.6149 14.5 10.7032V7.29665C14.5 6.38494 14.5 5.65007 14.4223 5.07209C14.3417 4.47201 14.1691 3.96677 13.7678 3.56549C13.4139 3.21161 12.9791 3.03557 12.4698 2.94359C12.2827 1.74795 11.2481 0.833252 10 0.833252ZM11.4195 2.84737C11.2177 2.25741 10.6584 1.83325 10 1.83325H7.33333C6.06212 1.83325 5.15901 1.83431 4.4739 1.92643C3.80317 2.0166 3.41674 2.18571 3.1346 2.46785C2.85246 2.74999 2.68335 3.13643 2.59317 3.80715C2.50106 4.49226 2.5 5.39537 2.5 6.66658V10.6666C2.5 11.325 2.92416 11.8843 3.51411 12.0861C3.49999 11.6795 3.49999 11.2197 3.5 10.7032V7.29665C3.49999 6.38494 3.49997 5.65007 3.57768 5.07209C3.65836 4.47201 3.83095 3.96677 4.23223 3.56549C4.63351 3.16421 5.13876 2.99161 5.73883 2.91093C6.31681 2.83323 7.05167 2.83324 7.9634 2.83325H10.0366C10.5531 2.83325 11.0129 2.83324 11.4195 2.84737ZM4.93934 4.27259C5.12385 4.08809 5.3829 3.96779 5.87208 3.90202C6.37565 3.83431 7.04307 3.83325 8 3.83325H10C10.9569 3.83325 11.6243 3.83431 12.1279 3.90202C12.6171 3.96779 12.8761 4.08809 13.0607 4.27259C13.2452 4.4571 13.3655 4.71615 13.4313 5.20533C13.4989 5.7089 13.5 6.37631 13.5 7.33325V10.6666C13.5 11.6235 13.4989 12.2909 13.4313 12.7945C13.3655 13.2837 13.2452 13.5427 13.0607 13.7273C12.8761 13.9118 12.6171 14.0321 12.1279 14.0979C11.6243 14.1655 10.9569 14.1666 10 14.1666H8C7.04307 14.1666 6.37565 14.1655 5.87208 14.0979C5.3829 14.0321 5.12385 13.9118 4.93934 13.7273C4.75483 13.5427 4.63453 13.2837 4.56877 12.7945C4.50106 12.2909 4.5 11.6235 4.5 10.6666V7.33325C4.5 6.37631 4.50106 5.7089 4.56877 5.20533C4.63453 4.71615 4.75483 4.4571 4.93934 4.27259Z"
        fill={color}
      />
      <path
        d="M5.66699 10.0001H6.33366V11.6667H11.667V10.0001H12.3337V11.6667C12.3337 12.0367 12.037 12.3334 11.667 12.3334H6.33366C5.96699 12.3334 5.66699 12.0367 5.66699 11.6667V10.0001ZM9.00033 11.0001L10.8503 9.18008L10.377 8.71008L9.33366 9.75008V6.66675H8.66699V9.75008L7.62699 8.71008L7.15366 9.18341L9.00033 11.0001Z"
        fill={color}
      />
    </svg>
  );
};

export default CopyDownloadIcon;
